module.exports = __webpack_public_path__ + "img/erro.a95541e3.png";